export default __webpack_public_path__ + "static/media/KOD0043-min.8489039e.webp";